import React from 'react';
import { fixPathFor } from '../data/fixPaths';
import './FixPath.css';

const OPEN = <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M18 14v5H5V6h5" /></svg>;
const CHECK = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7" /></svg>;
const LIST = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01" /></svg>;
const WRENCH = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.4-.6-.6-2.4z" /></svg>;

// "Sådan retter du det": where the finding is fixed in Microsoft's portals (portal and menu path), a button to the portal's front
// page and the button that puts the finding on the IT list. Shows nothing for a finding without a known path. NordComply changes nothing itself.
export default function FixPath({ findingKey, onList, onToggleList }) {
  const fix = fixPathFor(findingKey);
  if (!fix) return null;
  return (
    <div className="fixp">
      <div className="fixp__h">{WRENCH}<h6>Sådan retter du det</h6></div>
      <div className="fixp__p">
        <b>{fix.portal}</b>
        {fix.path.map((step) => <React.Fragment key={step}><i aria-hidden="true">›</i><span>{step}</span></React.Fragment>)}
      </div>
      <div className="fixp__a">
        <a className="fixp__b fixp__b--go" href={fix.url} target="_blank" rel="noopener noreferrer" title="NordComply ændrer intet selv. Rettelsen laves i Microsoft.">Åbn {fix.portal}{OPEN}</a>
        {onToggleList && (
          <button type="button" className={`fixp__b fixp__b--it${onList ? ' is-on' : ''}`} onClick={onToggleList} aria-pressed={onList}>
            {onList ? CHECK : LIST}{onList ? 'På IT-opgaver' : 'Tilføj til IT-opgaver'}
          </button>
        )}
      </div>
    </div>
  );
}
